<script lang="ts" setup>

  // @ts-expect-error avoid lint error
  import markdownParser from '@nuxt/content/transformers/markdown'

  const { content } = defineProps(['content']);

  // const content = locale.value === 'hu' ?  contenthu : contenten;
  let parsedMarkdown = await markdownParser.parse(null, content);

</script>

<template>
  <article class="prose" v-if="parsedMarkdown">
    <ContentRenderer :value="parsedMarkdown" v-bind="$attrs" />
  </article>
</template>
